export default {
  save_administrative_corrections(state: any, obj: any) {
    localStorage.setItem("administrative_corrections", JSON.stringify(obj))
    state.administrative_corrections = obj
  },
}
